module.exports = __webpack_public_path__ + "img/office_front.db6f7f73.jpg";